<template>
  <BoxCard class="mb-10">
    <template #header>Learning outcomes</template>
    <template #content>
      <div
        class="prose prose-sm prose-vice"
        v-html="this.$page.props.session.about.what_you_will_learn"
        v-if="checkIfHasContent(this.$page.props.session.about?.what_you_will_learn)"
      ></div>
      <div class="prose prose-sm prose-vice" v-else>
        <span class="text-gray-500 italic">No description</span>
      </div>
    </template>
  </BoxCard>
</template>

<script>
import BoxCard from '@/Components/Cards/BoxCard.vue';

export default {
  name: 'WhatYouLearn',
  components: {
    BoxCard,
  },
  methods: {
    checkIfHasContent(content) {
      if (content) {
        return Boolean(content.replace(/<\/?[^>]+(>|$)/g, ''));
      }
      return false;
    },
  },
};
</script>

<style scoped></style>
